import React from 'react';
import {Input} from '../general/Input';
import {ReactComponent as DeleteIcon} from '../../resources/imgs/delete_tag-icon.svg';
import {ReactComponent as EditIcon} from '../../resources/imgs/edit_tag-icon.svg';
import {ReactComponent as HideIcon} from '../../resources/imgs/hide_tag-icon.svg';
import {ReactComponent as SortIcon} from '../../resources/imgs/sort-icon.svg';
import {TAGS_ORDER_TYPES} from '../../actions/tags';
import {Tag} from "../../models/Tag";

interface Props {
  locale: string,
  tags: Tag[],
  style?: any | null,
  selectTagId: (tagId?: string | null) => void,
  setEditTag: (tag: Tag) => void,
  selectedTagId?: string | null,
  updateTag: (tag: Tag) => void,
  setDeleteTag: (tag: Tag) => void,
  orderParams: any,
  orderTags: (orderParams: any) => void,
}

export const LocaleTagColumn = ({
  locale, tags, style, selectTagId, setEditTag,
  selectedTagId, updateTag, setDeleteTag, orderParams, orderTags,
}: Props) => {
  const isEnglish = locale === 'en';
  const iconStyle = {paddingRight: '5px', paddingLeft: '5px', display: 'flex'};

  const renderInput = (tag: Tag) => {
    const value = isEnglish ? tag.name :
      (tag.localization[locale] && tag.localization[locale]['name'] ? tag.localization[locale]['name'] : '');

    return <Input debounce={800}
      className={'tag-input' + (selectedTagId === tag.id ? '-active' : '')}
      handleChange={(value: string) => {
        const newTag = {...tag};
        if (isEnglish) {
          newTag.name = value;
          if (newTag.name === '') {
            newTag.isActive = false;
          }
        }
        if (newTag.localization[locale] && newTag.localization[locale].name) {
          newTag.localization[locale].name = value;
        } else {
          newTag.localization[locale] = {name: value};
        }

        updateTag(newTag);
      }}
      value={value}
      placeholder={'-'}
    />;
  };

  const renderHeaderGeneralColumn = () => {
    return <div className={'tag-text'}
      style={{paddingTop: '14px', display: 'flex'}}
    >
      <div style={iconStyle}>
        <SortIcon/>
      </div>
      <div style={iconStyle}>
        <SortIcon className={'hover-icon'} onClick={() => {
          orderTags({
            orderBy: TAGS_ORDER_TYPES.IS_VISIBLE,
            orderIndex: orderParams.orderIndex === 'ASC' ? 'DESC' : 'ASC',
          });
        }}
        style={{fill: (orderParams.orderBy === TAGS_ORDER_TYPES.IS_VISIBLE ? '#232326' : '#B5B5B5')}}
        />
      </div>
      <div style={iconStyle}>
        <SortIcon className={'hover-icon'} onClick={() => {
          orderTags({
            orderBy: TAGS_ORDER_TYPES.IS_IMAGE,
            orderIndex: orderParams.orderIndex === 'ASC' ? 'DESC' : 'ASC',
          });
        }}
        style={{fill: (orderParams.orderBy === TAGS_ORDER_TYPES.IS_IMAGE ? '#232326' : '#B5B5B5')}}
        />
      </div>
      <div style={{...iconStyle, ...{width: '70px', paddingLeft: '20px'}}}>
        <SortIcon className={'hover-icon'} onClick={() => {
          orderTags({
            orderBy: TAGS_ORDER_TYPES.NAME,
            orderIndex: orderParams.orderIndex === 'ASC' ? 'DESC' : 'ASC',
          });
        }}
        style={{fill: (orderParams.orderBy === TAGS_ORDER_TYPES.NAME ? '#232326' : '#B5B5B5')}}
        />
      </div>
      <div style={iconStyle}>
        <SortIcon className={'hover-icon'} onClick={() => {
          orderTags({
            orderBy: TAGS_ORDER_TYPES.COUNT_TEMPLATES,
            orderIndex: orderParams.orderIndex === 'ASC' ? 'DESC' : 'ASC',
          });
        }}
        style={{fill: (orderParams.orderBy === TAGS_ORDER_TYPES.COUNT_TEMPLATES ? '#232326' : '#B5B5B5')}}
        />
      </div>
    </div>;
  };

  const renderGeneralColumn = () => {
    return <div className={'tag-locale-column'} style={{...style, ...{width: '220px'}}}>
      {renderHeaderGeneralColumn()}
      <div style={{display: 'flex', flexDirection: 'column', marginTop: '8px'}}>
        {tags.map((tag) => {
          return <div
            key={locale + tag.id}
            onClick={() => {
              selectTagId(tag.id);
            }}
            style={{display: 'flex', alignItems: 'center', marginTop: '8px'}}
          >
            <div style={iconStyle}>
              <DeleteIcon className={'hover-icon'} onClick={() => {
                setDeleteTag(tag);
              }}
              />
            </div>
            <div style={iconStyle}>
              <HideIcon className={'hover-icon'} onClick={() => {
                updateTag(
                    Object.assign({}, tag, {
                      isActive: !tag.isActive,
                    }),
                );
              }}
              style={{fill: (tag.isActive ? '#81E727' : '#B5B5B5')}}
              />
            </div>
            <div style={iconStyle}>
              <EditIcon className={'hover-icon'} onClick={() => {
                setEditTag(tag);
              }}
              style={{fill: (tag.imageUrl ? '#282828' : '#B5B5B5')}}
              />
            </div>
            {renderInput(tag)}
            <div style={{...iconStyle, ...{width: '30px'}}} className={'tag-text'}>
              {tag.templatesIds.length}
            </div>
          </div>;
        })}
      </div>
    </div>;
  };

  const renderLocaleColumn = () => {
    return <div className={'tag-locale-column'} style={style}>
      <div className={'tag-text'}
        style={{paddingTop: '14px', paddingLeft: '15px', paddingRight: '15px'}}
      >
        {locale.toUpperCase()}
      </div>
      <div style={{display: 'flex', flexDirection: 'column', marginTop: '8px'}}>
        {tags.map((tag) => {
          return <div
            key={locale + tag.id}
            onClick={() => {
              selectTagId(tag.id);
            }}
            style={{display: 'flex', alignItems: 'center', marginTop: '8px'}}
          >
            {renderInput(tag)}
          </div>;
        })}
      </div>
    </div>;
  };

  return isEnglish ? renderGeneralColumn() : renderLocaleColumn();
};
